/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Placewebcreated2Inputs */

const en_placewebcreated2 = /** @type {(inputs: Placewebcreated2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is saved as a draft`)
};

const de_placewebcreated2 = /** @type {(inputs: Placewebcreated2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist als Entwurf angelegt`)
};

/**
* | output |
* | --- |
* | "{name} is saved as a draft" |
*
* @param {Placewebcreated2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebcreated2 = /** @type {((inputs: Placewebcreated2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebcreated2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebcreated2(inputs)
	return de_placewebcreated2(inputs)
});
export { placewebcreated2 as "placeWebCreated" }